import DOMPurify from 'dompurify';
import './description.scss';
import classNames from 'classnames';

interface DescriptionProps {
  description: string;
  className?: string;
}

export default function Description({ description, className = '' }: Readonly<DescriptionProps>) {
  const cleanContent = DOMPurify.sanitize(description, {
    ALLOWED_TAGS: [
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'ol',
      'ul',
      'li',
      'span',
      'p',
      'strong',
      'em',
      'u',
      's',
      'blockquote',
      'a',
      'img',
      'video',
      'iframe',
      'i',
      'hr',
      'b'
    ],
    ALLOWED_ATTR: [
      'href',
      'target',
      'class',
      'src',
      'frameborder',
      'allowfullscreen',
      'style',
      'alt',
      'width',
      'height',
      'data-align'
    ],
    SANITIZE_NAMED_PROPS: true
  });

  DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    if ('target' in node) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });

  return <div className={classNames('description', className)} dangerouslySetInnerHTML={{ __html: cleanContent }} />;
}
